import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  channelState: null,
  channelTransaction: null,
  channelInfo: null,
  channelFinance: null,
  currentChannel: null,
  currentChannelView: null,
  bankInfo: null,
  bankInfoWithdraw: null,
  getTypeChooseYMW: null,
  getTypeChooseYear: null,
  getTypeChooseMonth: null,
  getChooseYear: null,
  getChooseMonth: null,
  getDataWeekInMonth: [],
  checkStatusFormatExcel: null,
  checkStatusBack:null,
  checkFromTime:null,
  checkToTime:null,
  checkTimeTest:null,
  callType:null,
  callFromTime:null,
  callToTime:null,
  statusChangeSeach:false
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    setChannelState(state, action) {
      state.channelState = action.payload;
    },
    setChannelTransaction(state, action) {
      state.channelTransaction = action.payload;
    },
    setChannelInfo(state, action) {
      state.channelInfo = action.payload;
    },
    setChannelFinance(state, action) {
      state.channelFinance = action.payload;
    },
    setCurrentChannel(state, action) {
      state.currentChannel = action.payload;
    },
    setCurrentChannelView(state, action) {
      state.currentChannelView = action.payload;
    },
    setBankInfo(state, action) {
      state.bankInfo = action.payload;
    },
    setBankInfoWithdraw(state, action) {
      state.bankInfoWithdraw = action.payload;
    },
    setGetTypeChooseYMW(state, action) {
      state.getTypeChooseYMW = action.payload;
    },
    setGetTypeChooseYear(state, action) {
      state.getTypeChooseYear = action.payload;
    },
    setGetTypeChooseMonth(state, action) {
      state.getTypeChooseMonth = action.payload;
    },
    setGetChooseMonth(state, action) {
      state.getChooseMonth = action.payload;
    },
    setGetChooseYear(state, action) {
      state.getChooseYear = action.payload;
    },
    setDataWeekInMonth(state, action) {
      state.getDataWeekInMonth = action.payload
    },
    setCheckStatusFormatExcel(state, action) {
      state.checkStatusFormatExcel = action.payload;
    },
    setCheckStatusBack(state, action) {
      state.checkStatusBack = action.payload;
    },
    setCheckFormTime(state, action) {
      state.checkFromTime = action.payload;
    },
    setCheckToTime(state, action) {
      state.checkToTime = action.payload;
    },
    setCheckTime(state, action){
      state.checkTimeTest = action.payload;
    },
    setCheckCallType(state, action) {
      state.callType = action.payload;
    },
    setCheckCallFromTime(state, action) {
      state.callFromTime = action.payload;
    },
    setCheckCallToTime(state, action){
      state.callToTime = action.payload;
    },
    setStatusChangeSeach(state, action){
      state.statusChangeSeach = action.payload;
    }
  },
});
const { actions, reducer } = channelSlice;
export const {
  setChannelState,
  setChannelTransaction,
  setChannelInfo,
  setChannelFinance,
  setCurrentChannel,
  setCurrentChannelView,
  setBankInfo,
  setBankInfoWithdraw,
  setGetTypeChooseYMW,
  setGetTypeChooseMonth,
  setGetTypeChooseYear,
  setGetChooseMonth,
  setGetChooseYear,
  setDataWeekInMonth,
  setCheckStatusFormatExcel,
  setCheckStatusBack,
  setCheckFormTime,
  setCheckToTime,
  setCheckTime,
  setCheckCallFromTime,
  setCheckCallType,
  setCheckCallToTime,
  setStatusChangeSeach
} = actions;
export default reducer;
